module dg.lists {
    angular.module('dg.lists', [
        'infinite-scroll',
        'ui.grid',
        //'ui.grid.pagination',
        //'ui.grid.infiniteScroll',
        //'ui.grid.autoResize',
        'ui.tree'
    ]).config($provide => {
        //Fixes UI-grid prevent vertical Based on https://github.com/angular-ui/ui-grid/issues/1926
        $provide.decorator('Grid', ($delegate, $timeout) => {
            $delegate.prototype.renderingComplete = function () {
                if (angular.isFunction(this.options.onRegisterApi)) {
                    this.options.onRegisterApi(this.api);
                }
                this.api.core.raise.renderingComplete(this.api);
                $timeout(function () {
                    var $viewport =   $('.ui-grid-render-container');
                    ['touchstart', 'touchmove', 'touchend', 'keydown', 'wheel', 'mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'].forEach(function (eventName) {
                        $viewport.unbind(eventName);
                    });
                }.bind(this));
            };
            return $delegate;
        });
    });
}